import Vue from 'vue'

import BaseComponent from '@base/component'
import NutritionLabel from '@models/nutrition-label'

var nutrition_horizontal = require('!pug-loader!./nutrition_horizontal.pug');
var nutrition_vertical = require('!pug-loader!./nutrition_vertical.pug');

export default Vue.extend({
    mixins: [ BaseComponent ],
    props: ['mdl'],
    data: function() {
        var keys = ['calories','fatCalories','totalFat','satFat','transFat','polyFat','monoFat','cholesterol','sodium','potassium','totalCarb','fiber','sugar','addedSugars','sugarAlcohol','protein','vitaminD','calcium','iron','vitaminA','vitaminC','vitaminE','vitaminK','thiamin','riboflavin','niacin','vitaminB6', 'folate', 'vitaminB12', 'pantothenicAcid', 'phosphorus', 'magnesium', 'zinc', 'selenium', 'copper', 'manganese', 'caffeine']
	if (this.mdl.hideNotApplicableValues) {
	    for (var k in keys) {
		this.mdl[k].show = this.mdl[k].na ? false : this.mdl[k].show;
	    }
	}

	if (this.mdl.hidePercentDailyValues) {
	    for (var k in keys) {
		this.mdl[k].showDaily = false;
	    }
	}
        
        return {
            model: this.mdl.toJSON ? this.mdl : new NutritionLabel(this.mdl, {parse:true}),
            keys: keys,
            vits: ['vitaminD', 'calcium', 'iron', 'potassium', 'vitaminA', 'vitaminC', 'vitaminE', 'vitaminK', 'thiamin', 'riboflavin', 'niacin', 'vitaminB6', 'folate', 'vitaminB12', 'pantothenicAcid', 'phosphorus', 'magnesium', 'zinc', 'selenium', 'copper', 'manganese'],
            items: [
                {key: 'totalFat', class1: 'nutrient', sep: 'hairlineseparator', class2: 'totalfatnewtabular'},
                {key: 'satFat', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'satfatnewtabular'},
                {key: 'transFat', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'transfatnewtabular'},
                {key: 'polyFat', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'polyunsatfatnewtabular'},
                {key: 'monoFat', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'monounsatfatnewtabular'},
                {key: 'cholesterol', class1: 'nutrient', sep: 'hairlineseparator', class2: 'cholesterolnewtabular'},
                {key: 'sodium', class1: 'nutrient', sep: 'hairlineseparator', class2: 'sodiumnewtabular'},
                {key: 'carbs', class1: 'nutrient', sep: 'hidden', class2: 'totalcarbsnewtabular'},
                {key: 'fiber', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'fibernewtabular'},
                {key: 'sugar', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'sugarnewtabular'},
                {key: 'addedSugar', class1: 'nutrientsubsubgroup', sep: 'subsubhairlineseparator', class2: 'addedsugarnewtabular'},
                {key: 'sugarAlcohol', class1: 'nutrientsubgroup', sep: 'hairlineseparator', class2: 'sugaralcoholnewtabular'},
                {key: 'protein', class1: 'nutrient', sep: 'hairlineseparator', class2: 'proteinnewtabular'},
                {key: 'filler', class1: 'nutrient invisible', sep: 'hairlineseparator', class2: 'new_filler_col_2'}
            ]
        };
    },
    methods: {
        labelhtml: function() {
            var data = this.model.toJSON();
	    data.method = 'main';
	    data.model = this.model;
            data.roundLoDash = this.model.roundLoDash;
	    var html = '';
	    if (this.model.style == 'vertical') {
	        html = nutrition_vertical(data);
            }
	    else
	        html = nutrition_horizontal(data);
            return html;
        }
    }
});
